module.exports = __webpack_public_path__ + "static/img/motor_roda-1.f922101.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/produtos/motor_roda-1.svg
// module id = u40L
// module chunks = 0